import { format } from 'date-fns';
import { Currency } from 'helpers/currency';
import { addIndex, map } from 'ramda';
import {
  Budget,
  AdvertiserType,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.types';

const buildDate = (
  date: Date,
  hours: number,
  minutes: number,
  seconds: number,
) => {
  date.setUTCHours(hours);
  date.setUTCMinutes(minutes);
  date.setUTCSeconds(seconds);
  return date.toISOString();
};

const mapIndexed = addIndex<Budget>(map);

const processBudgets = (
  budgets: Budget[],
  budgetName: string,
  budgetType: string,
  approvalDate: Date,
  campaignStart: string,
  campaignEndTm: string,
  budgetAdvertiserType: string,
) =>
  mapIndexed((budget, idx) => {
    const indexedBudget: any = {
      budgetType,
      budgetName,
      budgetAmount: {
        value: parseInt((budget.budgetAmount as unknown) as string),
        currency: Currency.USD,
      },
      approvalDate: format(new Date(approvalDate), 'yyyy-MM-dd'),
      budgetStartDate:
        idx === 0
          ? campaignStart
          : buildDate(new Date(budget.budgetStartDate), 0, 0, 0),

      budgetEndDate:
        idx === budgets.length - 1
          ? campaignEndTm
          : buildDate(new Date(budget.budgetEndDate), 23, 59, 59),
    };

    if (budgetAdvertiserType === AdvertiserType.MARKETPLACE) {
      indexedBudget.advertiser = {
        name: 'DOSH',
      };
    }

    return indexedBudget;
  }, budgets);
export { processBudgets };
